// return CATEGORY_NAMES;
import { BASE_URL } from "./constant";

export const getFinanceCategories = async () => {
  try {
    const response = await fetch(
      `${BASE_URL}/finance/get-all-finance-catagory/`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
      },
    );

    if (!response.ok) {
      throw new Error("Failed to fetch transaction categories");
    }

    const res = await response.json();
    const data = res.data;

    const categoryNames = {};
    data.forEach((cat) => {
      categoryNames[cat.id] =
        cat.catagory_name === "General Transaction"
          ? "General"
          : cat.catagory_name === "Material Transaction"
            ? "Material"
            : cat.catagory_name === "Worker Transaction"
              ? "Worker"
              : cat.catagory_name === "Refund"
                ? "Refund"
                : cat.catagory_name === "Received"
                  ? "Received"
                  : null;
    });
    const materialCategory = data.find(
      (cat) => cat.catagory_name === "Material Transaction",
    )?.id;
    const otherCategory = data.find(
      (cat) => cat.catagory_name === "General Transaction",
    )?.id;
    const workerCategory = data.find(
      (cat) => cat.catagory_name === "Worker Transaction",
    )?.id;
    const refundCategory = data.find(
      (cat) => cat.catagory_name === "Refund",
    )?.id;
    const receivedCategory = data.find(
      (cat) => cat.catagory_name === "Received",
    )?.id;
    localStorage.setItem("materialCategory", materialCategory);
    localStorage.setItem("otherCategory", otherCategory);
    localStorage.setItem("workerCategory", workerCategory);
    localStorage.setItem("refundCategory", refundCategory);
    localStorage.setItem("receivedCategory", receivedCategory);
    localStorage.setItem("categoryNames", JSON.stringify(categoryNames));
    return {
      data,
      categoryNames,
      materialCategory,
      otherCategory,
      workerCategory,
      refundCategory,
      receivedCategory,
    };
  } catch (error) {
    console.error("Error fetching transaction categories:", error);
    return {
      data: [],
      categoryNames: {},
      materialCategory: null,
      otherCategory: null,
      workerCategory: null,
      refundCategory: null,
      receivedCategory: null,
    };
  }
};
